import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DataGrid } from "@mui/x-data-grid";
import dayjs from "dayjs";
import { FETCH_DATA_TAG_USERS } from "../DataTagConstants";
import Page_Loader from "../../../assets/vizr_images/page_loader.gif";
import "./DataTagAllFilesTable.scss";
import FilterableHeader from "../Data Tag FIlters/FilterableHeader";
import DataTagUserSearch from "../Data Tag FIlters/DataTagUserSearch";
import SensitivityBadge from "../../../components/shared/Badge/SensitivityBadge";
import DataTagSensitivityFilter from "../Data Tag FIlters/DataTagSensitivityFilter";

const safe = (value) =>
  value === null || value === undefined || value === "" ? "-" : value;

export const renderDataTagNames = (users) => {
  if (!users || users.length === 0) return "-";
  return (
    <div className="dataEstateUsersTable" title={users}>
      {users}
    </div>
  );
};

export default function DataTagUsersTable() {
  const dispatch = useDispatch();
  const [selectedSensitivity, setSelectedSensitivity] = useState([]);

  const dataSourceId = useSelector(
    (state) => state.dataTagReducer.selectedDataSource?.id
  );

  const tableData = useSelector(
    (state) => state.dataTagReducer.users?.content || []
  );

  const totalCount = useSelector(
    (state) => state.dataTagReducer.users?.totalCount || 0
  );

  const [usernameFilter, setUsernameFilter] = useState([]);

  const [paginationModel, setPaginationModel] = useState({
    pageSize: 100,
    page: 0,
  });

  useEffect(() => {
    if (dataSourceId) {
      dispatch({
        type: FETCH_DATA_TAG_USERS,
        payload: {
          dataSourceId,
          page: paginationModel.page,
          size: paginationModel.pageSize,
          usernames: usernameFilter.length > 0 ? usernameFilter : null,
          sensitivity:
          selectedSensitivity.length > 0 ? selectedSensitivity : null,
        },
      });
    }
  }, [
    dataSourceId,
    paginationModel.page,
    paginationModel.pageSize,
    usernameFilter,
    selectedSensitivity,
  ]);

  const formatTime = (value) =>
    value
      ? `${dayjs(value).format("MM-DD-YYYY")} ${dayjs(value).format("HH:mm")}`
      : "-";

  const handlePaginationChange = (params) => {
    const newPagination = {
      pageSize: params.pageSize,
      page: params.page,
    };
    if (paginationModel.pageSize !== newPagination.pageSize) {
      newPagination.page = 0;
    }
    setPaginationModel(newPagination);
  };

  const columns = [
    {
      field: "userName",
      headerName: "User Name",
      flex: 1.5,
      renderHeader: () => (
        <FilterableHeader
          title="User Name"
          isFilterApplied={usernameFilter.length > 0}
          onApply={(selected) => setUsernameFilter(selected)}
          onClear={() => setUsernameFilter([])}
          onCancel={() => {}}
        >
          <DataTagUserSearch selectedValues={usernameFilter} />
        </FilterableHeader>
      ),
      renderCell: (p) => renderDataTagNames(p.value),
    },
    {
      field: "userEmail",
      headerName: "Email",
      flex: 2,
      renderCell: (p) => renderDataTagNames(p.value),
    },
    {
      field: "userRole",
      headerName: "Role",
      flex: 1.5,
      renderCell: (p) => safe(p.value),
    },
    {
      field: "sensitivityData",
      headerName: "Sensitivity",
      flex: 2,
      renderCell: (p) => {
        return (
          <div>
            <SensitivityBadge
              parentprops={p.value}
              loc="InspectContent"
              title={""}
            />
          </div>
        );
      },
    },
    {
      field: "fieldSize",
      headerName: "Files Size",
      flex: 0.7,
      headerAlign: "center",
      align: "center",
      renderCell: (p) => safe(p.value),
    },
    {
      field: "noOfPdaFiles",
      headerName: "PDA Files",
      headerAlign: "center",
      align: "center",
      flex: 1,
      renderCell: (p) => safe(p.value),
    },
    {
      field: "noOfFiles",
      headerName: "Total Files",
      headerAlign: "center",
      align: "center",
      flex: 1,
      renderCell: (p) => safe(p.value),
    },
  ];

  return (
    <div className="dt-all-files-table">
      <div className="quick-filter-bar">
        <span className="quick-filter-title">Sensitivity:</span>
        <DataTagSensitivityFilter
          value={selectedSensitivity}
          onChange={setSelectedSensitivity}
        />
      </div>
      <DataGrid
        rows={tableData.map((r, index) => ({ id: index + 1, ...r }))}
        columns={columns}
        className="mui-table"
        rowCount={totalCount}
        pagination
        paginationMode="server"
        paginationModel={paginationModel}
        onPaginationModelChange={handlePaginationChange}
        pageSizeOptions={[5, 10, 20, 50, 100]}
        sx={{
          "& .MuiDataGrid-virtualScroller": {
            overflowX: "hidden",
          },
        }}
      />
    </div>
  );
}
